import React from 'react';
import { Button } from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-dark">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/1a0277d6bbb7a859c6ad78f1ea2e4c5e.jpg')] bg-cover bg-center opacity-30"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-dark/80 via-dark/60 to-dark/90"></div>
      
      <div className="relative max-w-6xl mx-auto px-6 py-32 text-center">
        <div className="space-y-8">
          <div className="inline-flex items-center gap-2 bg-gray-800/80 border border-gray-700 rounded-full px-5 py-2.5">
            <span className="text-yellow-400 text-lg">⭐</span>
            <span className="text-sm font-medium text-gray-200 uppercase tracking-wide">
              +50 clínicas en España ya incorporaron a Mina
            </span>
          </div>
          
          <h1 className="text-5xl lg:text-7xl font-display font-bold text-white leading-[1.1] max-w-5xl mx-auto">
            La profesional IA que tu clínica{' '}
            <span className="bg-gradient-to-r from-pink-400 to-cyan-400 bg-clip-text text-transparent">incorpora</span>
            {' '}para vender 24/7
          </h1>
          
          <p className="text-xl lg:text-2xl text-gray-400 leading-relaxed max-w-4xl mx-auto">
            Mina es la agente especializada que atiende WhatsApp, Instagram, email, en menos de 3 segundos, agenda citas, optimiza los huecos libres, reduce el absentismo y re-activa pacientes sin descanso.
          </p>
          
          <div className="flex justify-center pt-4">
            <button 
              onClick={() => navigate('/demo')}
              className="px-8 py-3.5 text-base font-semibold text-white bg-gradient-to-r from-cyan-400 to-pink-400 rounded-lg hover:shadow-lg hover:shadow-pink-400/30 transition-all cursor-pointer whitespace-nowrap"
            >
              Ver a Mina en mi clínica
            </button>
          </div>
          
          <div className="flex items-center justify-center gap-6 pt-4 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-lg text-primary"></i>
              <span>Pago seguro con Stripe</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-lg text-primary"></i>
              <span>Sin permanencia</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
